import React from "react";
import tickIcon from '../../images/tick.svg';
import mutual from '../../images/mutual-funds-hero-image.webp';
import { Link } from "react-router-dom";
// import img from "https://d17x24txz4ixmz.cloudfront.net/images/mutual-funds-cover.png"; // Replace with actual path
import { Container, Row, Col, Button } from "react-bootstrap";
const MutualFund = () => {
  return (
    <div className="mutual-fund-section py-5">
      <div className="container text-center">
        <h1 className="">
          <span className="text-metual">Mutual Funds </span> for tax optimization

        </h1>
        <p className="mt-2 mb-5">
        We offer all types of financial products under one roof. The management team has more than 20 years of experience in financial sector.
        </p>
         <Link to={"/contact"}>
              
                          <Button className="get-in-touch mbl-hide me-3" >Get in touch</Button>
                          </Link>

        <div className="row align-items-center justify-content-center">
          <div className="col-md-2 text-end">
            <ul className="list-unstyled feature-list">
              <li><img  src={tickIcon} />Exclusive funds</li>
              <li><img  src={tickIcon} />Expert advice</li>
              <li><img  src={tickIcon} />Seamless investing</li>
            </ul>
          </div>

          <div className="col-md-6 my-3 my-md-0">
            <img src={mutual} alt="Mutual Fund Graphic" className="img-fluid" />
          </div>

          <div className="col-md-3 text-start">
            <ul className="list-unstyled feature-list">
              <li><img  src={tickIcon} />Tax tools</li>
              <li><img  src={tickIcon} />Custom strategies</li>
              <li><img  src={tickIcon} />Real-time updates</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MutualFund;
